import { MapPin, Phone, EnvelopeSimple, Clock } from "@phosphor-icons/react";
import Reveal from "@/components/Reveal";
import { SITE } from "@/lib/site";

export default function MapSection() {
  return (
    <section className="max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-32" data-testid="map-section">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12 items-start">
        <Reveal className="md:col-span-5">
          <div className="overline">Find us</div>
          <h2 className="font-serif text-4xl sm:text-5xl tracking-tight leading-tight mt-4">
            90 minutes from Melbourne.<br />
            <em className="italic font-light">A world away.</em>
          </h2>
          <ul className="mt-8 space-y-5 text-sa-ink2 text-[15px]">
            <li className="flex items-start gap-3">
              <MapPin size={20} weight="duotone" className="mt-0.5 text-sa-accent" />
              <div>
                <div className="text-sa-ink">{SITE.address}</div>
                <div className="text-sm">M8 → Western Hwy, Warrenheip exit</div>
              </div>
            </li>
            <li className="flex items-center gap-3">
              <Phone size={20} weight="duotone" className="text-sa-accent" />
              <a href={`tel:${SITE.phone_intl}`} className="hover:text-sa-ink">{SITE.phone}</a>
            </li>
            <li className="flex items-center gap-3">
              <EnvelopeSimple size={20} weight="duotone" className="text-sa-accent" />
              <a href={`mailto:${SITE.email}`} className="hover:text-sa-ink">{SITE.email}</a>
            </li>
            <li className="flex items-start gap-3">
              <Clock size={20} weight="duotone" className="mt-0.5 text-sa-accent" />
              <div>
                <div className="text-sa-ink">Reception 8am–8pm daily</div>
                <div className="text-sm">Late check-in by arrangement</div>
              </div>
            </li>
          </ul>
        </Reveal>

        <Reveal delay={120} className="md:col-span-7">
          <div className="rounded-2xl overflow-hidden border border-sa-ink/10 aspect-[4/3] bg-sa-bg2">
            <iframe
              title="Shady Acres Caravan Park location"
              src={SITE.mapEmbed}
              width="100%"
              height="100%"
              style={{ border: 0 }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
              data-testid="google-map"
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
